import * as _ from 'lodash';
import * as utility from '../misc/utility';
import { MissionGroup } from '../objects/MissionGroup';
import { ResourceEndpoint } from './ResourceEndpoint';

export class MissionGroupEndpoint extends ResourceEndpoint {
    constructor(url, api) {
        super(url, api, MissionGroup);
    }

    addToMissionGroup(missionGroupId, missions) {
        if (!utility.isGuid(missionGroupId)) throw "Invalid parameter, expected guid";

        var dst = this.url + '/' + encodeURIComponent(missionGroupId) + '/include';

        return this._api.postVoid(dst, {
            Id: missionGroupId,
            MissionIds: _.map(missions, x => x.Id),
        });
    }

    removeFromMissionGroup(missionGroupId, missions) {
        if (!utility.isGuid(missionGroupId)) throw "Invalid parameter, expected guid";

        var dst = this.url + '/' + encodeURIComponent(missionGroupId) + '/exclude';

        return this._api.postVoid(dst, {
            Id: missionGroupId,
            MissionIds: _.map(missions, x => x.Id),
        });
    }
}
